import * as React from 'react';
import {Component} from 'react';
import Typography from '@mui/material/Typography';
import {
    Avatar,
    CircularProgress,
    CssBaseline,
    Divider,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Modal,
    Stack,
    ThemeProvider
} from "@mui/material";
import {connect} from "react-redux";
import {message} from "antd";
import {defaultTheme} from "../gammaviewer/themes";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import {getReadStatusesForSlide} from "../../utils/api";
import {isNull, isTrue, notNull, stringForAvatar} from "../../utils/utils";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import cookie from "react-cookies";
import {aclPermissions, hasPermissions} from "../../const/ACLPermissions";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: 2,
};

class slideReadStatusModal extends Component {

    constructor(props) {
        super(props);
        this.state = this.initState();
    }

    initState = () => {

        return {
            readStatusData: null
        }
    }

    headingComponent = () => {
        const heading = "[ " + this.props.slideName + " ]";

        return <Stack direction={"row"} className={"flex-center"}>
            <Typography id="transition-modal-title" variant="h5" component="h5">
                {heading}
            </Typography>
        </Stack>
    }

    subHeadingComponent = (read) => {
        const text = read ? "Read" : "Unread";
        return (<Stack direction={"row"} spacing={1} sx={{py: 1, pt: 2}}>
            {read ? <DoneAllIcon sx={{color: 'blue'}}/> : <DoneAllIcon sx={{color: 'gray'}}/>}
            <Typography sx={{fontWeight: "bold"}}>{text}</Typography>
        </Stack>)
    }

    readStatuses = () => {
        if (isNull(this.state.readStatusData)) {
            return <div className={"full-parent flex-center"}><CircularProgress/></div>
        }
        if (this.state.readStatusData.length === 0) {
            return <Typography className={"full-parent flex-center"}>
                No Read Statuses Found
            </Typography>
        }

        const read_list_data = this.state.readStatusData.filter((item) => !isTrue(item.is_unread))
        const unread_list_data = this.state.readStatusData.filter((item) => isTrue(item.is_unread))

        let list_statuses_read, list_statuses_unread;

        if (read_list_data.length === 0) {
            list_statuses_read = <Typography className={"flex-center"}>
                It's empty here
            </Typography>
        } else {
            list_statuses_read = read_list_data.map((user) => {
                const is_z = user.timestamp.endsWith("Z")
                let update_time = user.timestamp.replace("Z", "")
                if (!is_z) {
                    update_time = update_time.substring(0, update_time.length-6)
                }
                const date_time = new Date(update_time);
                return (<><Divider orientation="horizontal"/>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                        <ListItem sx={{width: '55%', p: 0}}>
                            <ListItemAvatar>
                                <Avatar {...stringForAvatar(user.display_name, false)} />
                            </ListItemAvatar>
                            <ListItemText primary={user.display_name}
                                          secondary={user.name}
                                          primaryTypographyProps={{fontWeight: "medium"}}
                                          sx={{flex: 'none'}}/>
                        </ListItem>
                        <Stack direction={"column"} sx={{width: '40%', p: 0}} alignItems={"flex-end"}>
                            <Typography variant="caption">
                                {date_time.toLocaleString('en-us', {day: 'numeric', month: 'short', year: 'numeric'})}
                            </Typography>
                            <Typography variant="caption">
                                {date_time.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})}
                            </Typography>
                        </Stack>
                    </Stack></>)
            })
        }

        if (unread_list_data.length === 0) {
            list_statuses_unread = <Typography className={"flex-center"}>
                It's empty here
            </Typography>
        } else {
            list_statuses_unread = unread_list_data.map((user) => {
                return (<><Divider orientation="horizontal"/><Stack direction={"row"} alignItems={"center"}
                                                                    justifyContent={"space-between"}>
                    <ListItem sx={{width: '100%', p: 0}}>
                        <ListItemAvatar>
                            <Avatar {...stringForAvatar(user.display_name, false)} />
                        </ListItemAvatar>
                        <ListItemText primary={user.display_name}
                                      secondary={user.name}
                                      primaryTypographyProps={{fontWeight: "medium"}}
                                      sx={{flex: 'none'}}/>
                    </ListItem>
                </Stack></>)
            })
        }

        return (<Stack direction={"column"} className={"thin-scrollbar"} sx={{float: "left", maxHeight: "300", overflowY: "auto"}}>
            {this.subHeadingComponent(true)}
            {list_statuses_read}
            {this.subHeadingComponent(false)}
            {list_statuses_unread}
        </Stack>)

    }

    getRequiredData = () => {
        getReadStatusesForSlide(this.props.slideId).then(res => {
            if (res.status !== 200) {
                message.error("Error in fetching Read Statuses");
                this.setState({
                    readStatusData: []
                })
                return;
            }
            this.setState({
                readStatusData: res.data.res
            })
        }).catch(err => {
            this.setState({readStatusData: []})
            console.log(err)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.modalVisible !== this.props.modalVisible && isTrue(this.props.modalVisible) && notNull(this.props.slideId)) {
            this.setState(this.initState())
            this.getRequiredData();
        }
    }

    render() {

        if (!isTrue((cookie.load("organisation_setting") || {})["make_slide_read_config"]) || !hasPermissions([aclPermissions.share_slide])) {
            return null
        }

        const open = this.props.modalVisible

        return (
            <ThemeProvider theme={defaultTheme}>
                <CssBaseline/>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={this.props.closeModal}
                    closeAfterTransition
                    slots={{backdrop: Backdrop}}
                    slotProps={{
                        backdrop: {
                            timeout: 500,
                        },
                    }}
                >
                    <Fade in={open}>
                        <Box sx={style}>
                            <Stack direction={"column"} sx={{height: 500}}>
                                {this.headingComponent()}
                                {this.readStatuses()}
                            </Stack>
                        </Box>
                    </Fade>
                </Modal>
            </ThemeProvider>)
    }
}

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(slideReadStatusModal);